import React from 'react'
import { Link } from 'react-router-dom';
import { VideoCard } from './VideoCard';
import { ChannelCard } from './ChannelCard';

 const Video = (props) => {
    const {videos} = props;
    // const first = videos.splice(0,1);
    // console.log(first);
    // console.log(first[0]);
    // console.log(first[0]);
    // console.log(videos);

    console.log("HII");
  return (
    <div className='flex flex-col md:flex-row md:flex-wrap wrap gap-4 mt-4 items-center'>
       {
        videos?.map((video)=>(
        
            <div  >
                {video.id.videoId && <VideoCard video={video} />}
                {video.id.channelId && <ChannelCard video={video} />}
            </div>
            
        )
        )

            
        }</div>
       
   
  )
}

export default Video
